<template>
  <section class="section section--primary iframe-view">
    <div class="section__inner section__inner--quaternary">
      <div class="container">
        <h2 class="title title--primary">
          <span class="title__inner title__inner--primary">{{
            __("Checkout")
          }}</span>
        </h2>

        <a
          href="/booking"
          style="
            font-size: 1.3rem;
            margin: 0 auto;
            margin-bottom: 40px;
            display: block;
            text-align: center;
          "
          ><i class="fas fa-chevron-left"></i> &nbsp;{{
            __("Back to basket")
          }}</a
        >

        <app-checkout-partials-summary
          class="checkout-summary"
          :loading="summaryLoading"
          v-if="!loading"
          v-show="!summaryLoading"
          @loading="updateSummaryLoading"
        />

        <div class="checkout iframe-view">
          <div class="checkout__steps" v-show="!loading && !summaryLoading">
            <app-checkout-methods
              @update="updateMethod"
              @loading="updateLoading"
              @edit="edit(1)"
              @next="next"
              :completed="step > 1"
            />
            <app-checkout-tickets
              @update="updateTicket"
              @loading="updateLoading"
              @edit="edit(2)"
              @next="next"
              :ticket-printing-options="ticketPrintingOptions"
              :offer-collection="offerCollection"
              :collection-instructions="collectionInstructions"
              :force-collection="forceCollection"
              :print-charge="printCharge"
              :delivery-charge="deliveryCharge"
              :completed="step > 2"
              :tenant-id="tenantId"
              v-if="step > 1 && (ticketPrintingOptions === false || offerCollection === true)"
            />
            <app-checkout-ticket-holders
              :tenant-id="tenantId"
              @update="updateFields"
              @loading="updateLoading"
              @edit="edit(3)"
              @next="next"
              :method="method"
              :ticket="ticket"
              :completed="step > 3"
              v-if="step > 2"
            />
            <app-checkout-fields
              :address="address"
              :reservations="reservations"
              @update="updateFields"
              @loading="updateLoading"
              @edit="edit(4)"
              @next="next"
              :method="method"
              :ticket="ticket"
              :completed="step > 4"
              v-if="step > 3"
              :spectator-code-of-conduct="spectatorCodeOfConduct"
              :tenant="tenant"
              :how-did-you-hear-about-us-options="howDidYouHearAboutUsOptions"
            />

            <app-checkout-summary
              @loading="updateLoading"
              :method="method"
              :ticket="ticket"
              :completed="step > 5"
              v-if="step > 4"
            />
          </div>

          <div class="checkout__loading" v-if="loading || summaryLoading">
            <div class="loading loading--secondary">
              <div class="loading__spinner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Summary from "./Partials/Summary";

export default {
  props: {
    reservations: {
      required: false,
    },
    tenantId: {
      type: Number,
      required: false,
    },
    tenant: {
      type: Object,
      required: false,
    },
    address: {
      required: false,
    },
    spectatorCodeOfConduct: {
      type: Boolean,
      required: true,
    },
    howDidYouHearAboutUsOptions: {
      required: false
    },
    printCharge: {
      type: String,
      required: true
    },
    deliveryCharge: {
      type: String,
      required: true
    }
  },

  data: () => ({
    loading: true,
    summaryLoading: true,
    step: 1,
    method: "",
    ticket: "",
    fields: [],
    ticketPrintingOptions: false,
    offerCollection: false,
    forceCollection: false,
    collectionInstructions: null
  }),

  components: {
    "app-checkout-partials-summary": Summary,
  },

  mounted() {
    var reservations = Object.values(this.reservations)
    if (reservations.find(o => o.offer_collection == 1)) {
        this.offerCollection = true;

        var result;
        if (result = reservations.find(o => (o.collection_instructions != '' && o.collection_instructions !== null))) {
            this.collectionInstructions = result.collection_instructions;
        }

        if (reservations.find(o => o.force_collection == 1)) {
            this.forceCollection = true;
        }
    }
    if (reservations.find(o => o.ticket_printing_options == 1)) {
        this.ticketPrintingOptions = 1;
    } else if (reservations.find(o => o.ticket_printing_options == 2)) {
        this.ticketPrintingOptions = 2;
    }
  },

  methods: {
    updateMethod(handle) {
      this.method = handle;
    },
    updateTicket(ticket) {
      this.ticket = ticket;
    },
    updateFields(fields) {
      this.fields = fields;
    },
    updateLoading(loading) {
      this.loading = loading;
    },
    updateSummaryLoading(loading) {
      this.summaryLoading = loading;
    },
    next() {
      this.step++;
    },
    edit(step) {
      this.step = step;
    },
  },
  watch: {
    step: function(handle) {
        var skipStep = false;
        if (this.forceCollection == true && this.ticketPrintingOptions == 1) {
            this.ticket = 'printed_collection';
            skipStep = true;
        } else if (this.ticketPrintingOptions != false && this.offerCollection == false) {
            this.ticket = this.ticketPrintingOptions === 1 ? 'printed' : 'eticket';
            skipStep = true;
        }
        if (handle == 2 && skipStep === true) {
            axios.post('/checkout/ticket', {
                ticket: this.ticket
            }).then(() => {
                this.next();
            });
        }
    }
  }
};
</script>

<style lang="scss">
.checkout__accordion__title--done {
  opacity: 0.25;

  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 1;

    text-decoration: none;
  }
}

.checkout-summary {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Wrapper.vue